import { render } from "./Date.vue?vue&type=template&id=5c426218"
import script from "./Date.vue?vue&type=script&lang=ts"
export * from "./Date.vue?vue&type=script&lang=ts"
script.render = render

export default script